export const CONTACT = {
  address: "5-B/2, Indore Samachar Bhawan, Press Complex, A.B. Road Indore, Madhya Pradesh 452010",
  email: "siddharthoffsets@gmail.com",
  whatsapp: "+91 93025 41654",
  whatsappHref:
    "https://wa.me/919302541654?text=" +
    encodeURIComponent("Hello Siddharth Offsets, I'd like to enquire about a printing job."),
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("5-B/2, Indore Samachar Bhawan, Press Complex, A.B. Road Indore, Madhya Pradesh 452010"),
};

export const CMYK = ["#00AEEF", "#EC008C", "#FFD200", "#0E0E0E"];

export const SERVICES = [
  { num: "01", title: "Brochures", desc: "Multi-fold, saddle-stitched and gate-fold brochures with razor-sharp CMYK registration." },
  { num: "02", title: "Catalogs", desc: "High-volume product catalogs, perfect-bound or wire-o, colour-matched cover to cover." },
  { num: "03", title: "Packaging", desc: "Cartons, sleeves and rigid boxes. Die-cut, foiled, laminated — built to hold shelf presence." },
  { num: "04", title: "Labels", desc: "Sheet-fed label runs with spot UV, metallics and precision die-cutting at scale." },
  { num: "05", title: "Magazines", desc: "Periodicals and journals printed on deadline. Consistent ink density, issue after issue." },
  { num: "06", title: "Books", desc: "Text books, notebooks and publications. Section-sewn, perfect-bound, delivered on time." },
];

export const SERVICE_OPTIONS = ["Brochures", "Catalogs", "Packaging", "Labels", "Magazines", "Books", "Other"];

export const QUANTITY_OPTIONS = ["Under 1,000", "1,000 – 5,000", "5,000 – 10,000", "10,000 – 50,000", "50,000+"];

export const STATS = [
  { value: "25+", label: "Years on press", color: "#00AEEF" },
  { value: "4", label: "Colour offset units", color: "#EC008C" },
  { value: "10M+", label: "Sheets printed yearly", color: "#FFD200" },
  { value: "48h", label: "Fastest turnaround", color: "#FF3B30" },
];

export const MANIFESTO = [
  {
    num: "01",
    color: "#00AEEF",
    title: "Ink is a promise.",
    body: "Every sheet that leaves our press at Press Complex, Indore carries our name on it. We calibrate, proof and re-proof until the colour on paper matches the colour in your head. No approximations.",
  },
  {
    num: "02",
    color: "#EC008C",
    title: "Deadlines are sacred.",
    body: "Print runs don't wait, and neither do launches. We plan every job backwards from your delivery date — plates, paper, press time, finishing — so the truck leaves when we said it would.",
  },
  {
    num: "03",
    color: "#FFD200",
    title: "Scale without compromise.",
    body: "From a 500-piece brochure run to a 50,000-copy catalog, the first sheet and the last sheet are indistinguishable. That is the entire point of offset — and we push it to the edge.",
  },
];
